import { useMemo } from 'react';
import { select } from '~/lib/select';
import { TrainingState, useTrainingStore } from '.';

const selector = (s: TrainingState) => select(s, 'activeItemPosition', 'items');

/**
 * Calculates the distance in the nav between the current item and the item with the given id
 * @param id The target item id
 */
export function useNavDistance(id: string) {
  const { activeItemPosition, items } = useTrainingStore(selector);

  return useMemo(() => {
    const activeIndex = items.findIndex(i => i.position === activeItemPosition);
    const index = items.findIndex(i => i.id === id);
    if (index === -1) return NaN;

    return index - activeIndex;
  }, [id, activeItemPosition, items]);
}
